import React from 'react';
import { Modal, Button } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import './AlertModal.css';

interface AlertModalProps {
  isOpen: boolean;
  title: string;
  description: string | React.ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmText?: string;
  confirmButtonType?: 'primary' | 'default' | 'dashed' | 'link' | 'text';
  confirmDanger?: boolean;
}

const AlertModal: React.FC<AlertModalProps> = ({
  isOpen,
  title,
  description,
  onCancel,
  onConfirm,
  confirmText = 'Delete',
  confirmButtonType = 'primary',
  confirmDanger = true,
}) => {
  return (
    <Modal
      open={isOpen}
      onCancel={onCancel}
      footer={null}
      closable={true}
      closeIcon={<span className="close-icon">×</span>}
      className="alert-modal"
      width={400}
      centered
    >
      <div className="alert-modal-content">
        <img src="/images/alert.svg" className="warning-icon" />
        <div className="alert-modal-text">
          <h3>{title}</h3>
          <p>{description}</p>
        </div>
        <div className="alert-modal-footer">
          <Button type="link" onClick={onCancel}>Cancel</Button>
          <Button
            type={confirmButtonType}
            danger={confirmDanger}
            onClick={onConfirm}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AlertModal;